import './tastekitchen/style';
import FormStructure from './tastekitchen/form_structure';

export default FormStructure;